// The admin dashboard frame: admins only, with the dashboard's navigation.
import type { ReactNode } from "react";
import { Link, usePath } from "../../lib/router";
import { useSession } from "../../session";

const NAV: [string, string][] = [
  ["/admin", "Overview & moderation"],
  ["/admin/planner", "Planner"],
  ["/admin/lab", "Sound Lab"],
];

export function AdminShell({ children, wide = false }: { children: ReactNode; wide?: boolean }) {
  const user = useSession((s) => s.user);
  const loaded = useSession((s) => s.loaded);
  const path = usePath();
  if (!loaded)
    return (
      <main id="main" className="page">
        <p className="muted">Loading…</p>
      </main>
    );
  if (!user?.isAdmin)
    return (
      <main id="main" className="page narrow">
        <h1>Admin</h1>
        <p>Admins only.</p>
      </main>
    );
  return (
    <main id="main" className={`page admin-page${wide ? " page-wide" : ""}`}>
      <nav className="admin-nav" aria-label="Admin">
        <span className="admin-nav-title">Admin</span>
        {NAV.map(([href, label]) => (
          <Link
            key={href}
            href={href}
            className={`admin-nav-link${path === href ? " on" : ""}`}
            aria-current={path === href ? "page" : undefined}
          >
            {label}
          </Link>
        ))}
      </nav>
      {children}
    </main>
  );
}
